export var defaultMapOptions = {
  style: "mapbox://styles/mapbox/streets-v11",
  container: "search-map-container",
  attributionControl: false,
  compact: false,
  animate: false,
  maxZoom: 18,
  zoom: 12
};
export var defaultPopupOptions = {
  closeButton: false,
  closeOnClick: true,
  closeOnMove: false,
  maxWidth: "none",
  anchor: "bottom",
  offset: -10
};